export default __webpack_public_path__ + "locales/en/PeopleTranslations.json?hash=8140a0cdfb59a397073a112b58d12592";